import { InstrumentRepository } from '../../repositories/instrument/instrument.repository'
import InstrumentModel from '../../models/instrument.model'

export default class InstrumentsController {
  constructor(private instrumentRepository: InstrumentRepository) {}

  async getAllInstruments(): Promise<InstrumentModel[]> {
    return this.instrumentRepository.getInstruments();
  }
}